/** Tempat banner utama selagi data konten beranda dimuat: bingkai rasio terkunci,
 *  diisi versi mini buram bila ada, tanpa teks/tombol sehingga tidak menyesatkan. */
export function HeroTempat({ mini }) {
  return (
    <section className="w-full" data-testid="hero-tempat">
      <div className="relative w-full overflow-hidden aspect-[2/1] md:aspect-[21/5] bg-[#1D1D1F]">
        {mini ? (
          <div
            className="absolute inset-0 bg-center bg-cover"
            style={{ backgroundImage: `url(${mini})`, filter: "blur(14px)", transform: "scale(1.08)" }}
            data-testid="hero-mini-blur"
          />
        ) : null}
      </div>
    </section>
  );
}
